@if (!isLoading) {
  <div>
    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-fieldset-header [legend]="'Teams Compliance Recording'">
        <ziro-select [fieldId]="'complianceRecordingPolicy'"></ziro-select>
      </ziro-fieldset-header>
      <ziro-fieldset-header [legend]="'Dubber User Settings'">
        <ziro-text [fieldId]="'email'"></ziro-text>
        <ziro-text [fieldId]="'firstName'"></ziro-text>
        <ziro-text [fieldId]="'lastName'"></ziro-text>
        <ziro-text [fieldId]="'mobileNumber'"></ziro-text>
        <ziro-select [fieldId]="'region'"></ziro-select>
        <ziro-select [fieldId]="'product'"></ziro-select>
      </ziro-fieldset-header>
    </ziro-collapsible-section-card>
  </div>
}
